export function formatCredits(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '';
  }

  return Number(value).toFixed(2);
}
